interface Props {
  bold?: true;
}
export const IconCross = ({ bold }: Props) => {
  const width = bold ? '3.6' : '1.8';

  return (
    <svg viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="m6 6 12 12"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#4a4a4a"
          strokeWidth={width}
        />
        <path
          d="m6 18 12-12"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="#4a4a4a"
          strokeWidth={width}
        />
      </g>
    </svg>
  );
};
